/* eslint-disable max-len */
import { Icon } from '@kinesis/bungle';

const EvaluateIcon = () => (
  <Icon type='custom' magnitude='medium'>
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.0859 16.7969H1.83594C1.49023 16.7969 1.21094 16.5176 1.21094 16.1719V3.67188C1.21094 3.32617 1.49023 3.04688 1.83594 3.04688H18.0859C18.4316 3.04688 18.7109 3.32617 18.7109 3.67188V16.1719C18.7109 16.5176 18.4316 16.7969 18.0859 16.7969ZM16.2832 13L10.4824 7.19531C10.4531 7.16623 10.4134 7.14992 10.3721 7.14992C10.3307 7.14992 10.2911 7.16623 10.2617 7.19531L8.02539 9.43164L4.65625 6.06055C4.62688 6.03147 4.58723 6.01516 4.5459 6.01516C4.50457 6.01516 4.46491 6.03147 4.43555 6.06055L3.7168 6.7793C3.68772 6.80866 3.67141 6.84832 3.67141 6.88965C3.67141 6.93098 3.68772 6.97063 3.7168 7L7.91406 11.1992C7.97461 11.2598 8.07422 11.2598 8.13477 11.1992L10.3711 8.96484L15.3418 13.9375C15.4023 13.998 15.502 13.998 15.5625 13.9375L16.2812 13.2187C16.3438 13.1602 16.3438 13.0605 16.2832 13Z'
        fill='white'
        fillOpacity='0.85'
      />
    </svg>
  </Icon>
);

export { EvaluateIcon };
